import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app/App'
import './styles/globals.css'

// Demo mode for documentation screenshots — DEV ONLY, opt-in per run:
//     VITE_DEMO=1 npm run dev
// `import.meta.env.DEV` is statically false in a production build, so this
// whole block (and the dynamic import inside it) is removed by dead-code
// elimination and never ships. Verified by grepping the built bundle.
if (import.meta.env.DEV && import.meta.env.VITE_DEMO === '1') {
  void import('./lib/demo-mode').then(({ installDemoMode }) => installDemoMode())
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
